import { render, staticRenderFns } from "./HeaderComponent.vue?vue&type=template&id=57f70cd9&scoped=true"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./HeaderComponent.vue?vue&type=style&index=0&id=57f70cd9&prod&lang=scss"
import style1 from "./HeaderComponent.vue?vue&type=style&index=1&id=57f70cd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f70cd9",
  null
  
)

export default component.exports